import DialogContent from '@elementor/ui/DialogContent';
import { styled } from '@elementor/ui/styles';
import { useState, useMemo } from 'react';
import { useScannerWizardContext } from '@context/scanner-wizard-context';
import StepSubscriptionFormLoader from './loader';

const GetFreeModalStepSubscriptionForm = () => {
	const [isLoaded, setIsLoaded] = useState(false);
	const { pageURL } = useScannerWizardContext();

	// Build iframe URL with scanned URL as query parameter
	const iframeSrc = useMemo(() => {
		const baseUrl = 'https://elementor.com/tools/ally-checker-form/';
		if (pageURL) {
			const url = new URL(baseUrl);
			url.searchParams.set('url', pageURL);
			return url.href;
		}
		return baseUrl;
	}, [pageURL]);

	return (
		<StyledContent dividers>
			{!isLoaded && <StepSubscriptionFormLoader />}

			<StyledIframe
				width="769"
				height="572"
				title="Product new subscription form"
				src={iframeSrc}
				onLoad={() => setIsLoaded(true)}
				style={{ visibility: isLoaded ? 'visible' : 'hidden' }}
			/>
		</StyledContent>
	);
};

const StyledContent = styled(DialogContent)`
	position: relative;

	width: 100%;
	min-width: 580px;
	min-height: 620px;

	padding: ${({ theme }) =>
		`${theme.spacing(2)} ${theme.spacing(3)} ${theme.spacing(4)}`};

	overflow: hidden;
`;

const StyledIframe = styled('iframe')`
	position: absolute;
	inset-inline-start: 50%;

	width: 769px;
	height: 100%;

	display: block;

	border: 0;
	transform: translateX(-50%);
`;

export default GetFreeModalStepSubscriptionForm;
